import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';
import { AIServiceEnum } from './dataRegistry';

interface SetServiceAndVersionPayload {
  service: AIServiceEnum;
  version: string;
}

interface DataMeshState {
  currService: AIServiceEnum | null;
  currServiceVersion: string | null;
}

const initialState: DataMeshState = {
  currService: null,
  currServiceVersion: null,
};

export const dataMeshSlice = createSlice({
  name: 'dataMesh',
  initialState,
  reducers: {
    initDataMeshState: () => initialState,
    setServiceAndVersion: (
      state,
      action: PayloadAction<SetServiceAndVersionPayload>
    ) => {
      state.currService = action.payload.service;
      state.currServiceVersion = action.payload.version;
    },
    resetServiceVersion: (state) => {
      state.currService = null;
      state.currServiceVersion = null;
    },
  },
});

export const { initDataMeshState, setServiceAndVersion, resetServiceVersion } =
  dataMeshSlice.actions;

export const selectCurrService = (state: RootState) =>
  state.dataMesh.currService;
export const selectCurrServiceVersion = (state: RootState) =>
  state.dataMesh.currServiceVersion;
export const selectAllDataMeshState = (state: RootState) => state.dataMesh;

export default dataMeshSlice.reducer;
